import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-add-groups-list', {
    position: 'relative',
    height: '200px',
    '-ms-filter': '\'progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\'',
    filter: 'alpha(opacity=100)',
    opacity: 1,
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
    marginTop: '12px',
});

cssRule('.tb-add-groups-list.tb-initial-state', {
    height: '0px',
    '-ms-filter': '\'progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\'',
    filter: 'alpha(opacity=0)',
    opacity: 0,
});

cssRule('.tb-add-groups-list .tb-scroll', {
    margin: '3px',
});

cssRule('.tb-add-groups-dialog-message', {
    fontSize: '11px',
    height: '16px',
});

cssRule('.tb-add-groups-dialog-message, .tb-add-groups-dialog-timeout-message', {
    marginTop: '6px',
});

cssRule('.tb-error-color', {
    color: applyColor(DesignTokens.color.font.default.error, '#c41723'),
});

cssRule('.tb-import-group-site-role-picker', {
    position: 'relative',
    height: '20px',
    marginTop: '10px',
    '-ms-filter': '\'progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\'',
    filter: 'alpha(opacity=100)',
    opacity: 1,
});

cssRule('.tb-import-group-site-role-picker.tb-initial-state', {
    height: '0px',
    marginTop: '0px',
    '-ms-filter': '\'progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\'',
    filter: 'alpha(opacity=0)',
    opacity: 0,
});

cssRule('.tb-create-group-site-role-picker', {
    position: 'relative',
    marginTop: '10px',
    '-ms-filter': '\'progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\'',
    filter: 'alpha(opacity=100)',
    opacity: 1,
});

cssRule('.tb-create-group-site-role-picker.tb-initial-state', {
    height: '0px',
    marginTop: '0px',
    '-ms-filter': '\'progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\'',
    filter: 'alpha(opacity=0)',
    opacity: 0,
});

cssRule('.tb-import-group-dialog-actions', {
    marginTop: '18px',
    whiteSpace: 'nowrap',
});

